// ISO 3166-1 alpha-2 country codes mapping
export const COUNTRY_CODES = {
  'GB': 'United Kingdom',
  'US': 'United States',
  'CA': 'Canada',
  'AU': 'Australia',
  'DE': 'Germany',
  'FR': 'France',
  'ES': 'Spain',
  'IT': 'Italy',
  'NL': 'Netherlands',
  'BE': 'Belgium',
  'PT': 'Portugal',
  'BR': 'Brazil',
  'AR': 'Argentina',
  'MX': 'Mexico',
  'JP': 'Japan',
  'KR': 'South Korea',
  'IE': 'Ireland',
  'PL': 'Poland',
  'GR': 'Greece',
  'CH': 'Switzerland',
  'AT': 'Austria',
  'SE': 'Sweden',
  'NO': 'Norway',
  'DK': 'Denmark',
  'FI': 'Finland',
  'CZ': 'Czech Republic',
  'HU': 'Hungary',
  'RO': 'Romania',
  'BG': 'Bulgaria',
  'HR': 'Croatia',
  'RS': 'Serbia',
  'TR': 'Turkey',
  'RU': 'Russia',
  'UA': 'Ukraine',
  'IN': 'India',
  'CN': 'China',
  'SG': 'Singapore',
  'NZ': 'New Zealand',
  'ZA': 'South Africa',
  'EG': 'Egypt',
  'NG': 'Nigeria',
  'KE': 'Kenya',
  'GH': 'Ghana',
  'OTHER': 'Other'
};

// Reverse mapping: country name to ISO code
export const COUNTRY_NAME_TO_CODE = Object.fromEntries(
  Object.entries(COUNTRY_CODES).map(([code, name]) => [name, code])
);

// Get country name from ISO code
export function getCountryName(code) {
  return COUNTRY_CODES[code] || code || 'Unknown';
}

// Get ISO code from country name
export function getCountryCode(name) {
  return COUNTRY_NAME_TO_CODE[name] || name || 'OTHER';
}

// Get flag emoji from ISO country code (e.g., 'GB' -> 🇬🇧)
export function getCountryFlag(code) {
  if (!code || code.length !== 2) return '';
  return code
    .toUpperCase()
    .split('')
    .map(char => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join('');
}


// List of countries for dropdowns (sorted by name)
export const COUNTRIES_LIST = Object.entries(COUNTRY_CODES)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name));

